import * as React from 'react';
import { LazyLoadComponentWrapper } from '@components/lazy-load/lazy-load-component-wrapper';
import { TpamsCardLoadingIndicator } from '../../../../components/tpams-card-loader';
import { ICardProps } from '@components/cards/card-wrapper';

const cardTitle = 'Reporting and performance';
const DashboardCard = React.lazy(
    () => import(/* webpackChunkName:"tpams-card" */ './index')
);
type ITPAMSReportsCardOwnProps = ICardProps;

export const NewCard = (props: ITPAMSReportsCardOwnProps) => (
    <LazyLoadComponentWrapper
        fallback={<TpamsCardLoadingIndicator error={false} cardTitle={cardTitle} />}
        errorIndicator={
            <TpamsCardLoadingIndicator error={true} cardTitle={cardTitle} />
        }
    >
        <DashboardCard {...props} />
    </LazyLoadComponentWrapper>
);
